// extracted by mini-css-extract-plugin
export default {"resumeContainer":"resume_resumeContainer__fSpp-","row":"resume_row__YKeCv","downloadBtn":"resume_downloadBtn__llZSt","resume":"resume_resume__xAeFx","file":"resume_file__MHz1z"};